import { useEffect } from 'react'

export const useBodyOverflowHidden = (searchOpen: boolean) => {
  useEffect(() => {
    const body = document.body

    if (searchOpen) {
      body.classList.add('overflow-hidden')
    } else {
      body.classList.remove('overflow-hidden')
    }

    return () => body.classList.remove('overflow-hidden')
  }, [searchOpen])
}
